import { SectionCard } from '../../regional/BucketStates';
import { EM_DASH, formatCents, formatPayDate } from '../payFormat';
import type { PayGroup } from '../teacherApi';

import ShiftTable from './ShiftTable';

export default function PayDateGroup({
  group,
  salaried = false,
}: {
  group: PayGroup;
  salaried?: boolean;
}) {
  const title = `${group.isPast ? 'Paid' : 'Pays'} ${formatPayDate(group.payDateIso)}`;
  return (
    <SectionCard
      title={title}
      action={
        salaried ? undefined : (
          <span className="nb-tabular nb-mono" style={{ fontSize: 13, fontWeight: 700 }}>
            {group.totalCents === null ? EM_DASH : formatCents(group.totalCents)}
          </span>
        )
      }
    >
      <p style={{ margin: '0 0 8px', fontSize: 11, color: 'var(--nb-subtle)' }}>
        Covers {formatPayDate(group.coversFromIso)} – {formatPayDate(group.coversToIso)}
      </p>
      <ShiftTable shifts={group.shifts} salaried={salaried} />
      {!salaried && group.totalCents === null && (
        <p role="status" style={{ margin: '8px 0 0', fontSize: 11, color: 'var(--nb-warn)' }}>
          No total shown: one or more shifts here have no configured rate, so a sum would be
          misleading.
        </p>
      )}
    </SectionCard>
  );
}
